import { LayoutConfig } from 'js/model/state/layout';
import { ViewMode } from './ViewModeToggle';

export function layoutConfig(mode?: ViewMode): LayoutConfig {
  const hide = mode === ViewMode.Map;
  return { header: { hide }, footer: { hide } };
}
